import store from '@/store'
import VueJwtDecode from 'vue-jwt-decode'
import {userService} from '@/services'

let getToken = () => {
    const session = JSON.parse(sessionStorage.getItem('session'));
    return session?.token
}

let isTokenValid = () => {
    const sessionData = JSON.parse(sessionStorage.getItem('session'))
    const token = sessionData?.token
    try{
        if(token) {
            let decoded = VueJwtDecode.decode(token)
            const isValid = ((decoded.exp > Date.now()/1000) || (decoded.nbf > Date.now()/1000))
            return isValid;
        }
        else{ return false}
    }catch (_error) {
        console.log('--------------isTokenValid Error---------------');
        console.log(_error)
        alert('--------------isTokenValid Error---------------');
        userService.logout();
        return false
    }
}

let updateLicence = (licence) => {
    let session = JSON.parse(sessionStorage.getItem("session"))
    session.licence = licence
    sessionStorage.setItem("session", JSON.stringify(session))
    store.dispatch('setSession', session)
}

let updateLocale = (locale) => {
    let session = JSON.parse(sessionStorage.getItem("session"))
    session.locale = locale
    sessionStorage.setItem("session", JSON.stringify(session))
    store.dispatch('setSession', session)
}

let updateLocalAccessToken = (refreshToken) => {
    if(typeof refreshToken === 'string' && refreshToken !== ""){
         let session = JSON.parse(sessionStorage.getItem("session"))
         session.token = refreshToken
         sessionStorage.setItem("session", JSON.stringify(session))
         store.dispatch('setSession', session)
    }
}

export const tokenService = {
    getToken,
    isTokenValid,
    updateLicence,
    updateLocale,
    updateLocalAccessToken,
}